import { Container, Grid, Paper } from '@material-ui/core'
import React from 'react'
import { components, useTranslation } from 'cng-web-lib'

import AccessLevelCompanyViewForm from './AccessLevelCompanyViewForm'
import AccessLevelCompanyRuleCrudTable from './AccessLevelCompanyRuleCrudTable'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import AccessLevelCompanyKeys from 'src/constants/locale/key/AccessLevelCompany'

const { CngTabs } = components


function ViewPage({ showNotification }) {
	const { id } = useParams()
  const { translate } = useTranslation([Namespace.ACCESS_LEVEL_COMPANY])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let accessLevelCompany = translate(
      Namespace.ACCESS_LEVEL_COMPANY,
      AccessLevelCompanyKeys.TITLE
    )
    let accessLevelCompanyRule = translate(
      Namespace.ACCESS_LEVEL_COMPANY,
      AccessLevelCompanyKeys.AccessLevelCompanyRule.TITLE
    )

    return {
      accessLevelCompany,
      accessLevelCompanyRule
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <AccessLevelCompanyViewForm
							showNotification={showNotification}
							id={id}
							onFetchPreSuccess={() => {console.log("Access level company view page")}}
						/>
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.accessLevelCompany,
              tabContent: (
                <AccessLevelCompanyViewForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
            {
              tabName: translatedTextsObject.accessLevelCompanyRule,
              tabContent: (
                <AccessLevelCompanyRuleCrudTable
                  showNotification={showNotification}
                  accessLevelCompanyId={id}
                  isViewOnly={true}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default ViewPage